import { useMemo } from "react";

function useFilterTags(selectedView, KPIWiseFilters, KPIWiseLocalFilters) {
  return useMemo(() => {
    const filterTags = new Map();

    if (selectedView) {
      selectedView.metadata.KPIs.forEach((kpi) => {
        const KPIWidgetFilters = KPIWiseFilters && KPIWiseFilters[kpi] ? KPIWiseFilters[kpi] : null;
        const KPILocalFilters =
          KPIWiseLocalFilters && KPIWiseLocalFilters[kpi] ? KPIWiseLocalFilters[kpi] : null;

        if (KPIWidgetFilters) {
          const KPIWidgetFilterDimensions = KPIWidgetFilters.filterDimensions;
          const KPIWidgetFilterDimensionValues = KPIWidgetFilters.filterDimensionValues;

          KPIWidgetFilterDimensions.forEach((d, i) => {
            filterTags.set(d, {
              filterDimension: d,
              filterDimensionValues: __getCombinedUniqueVals(
                d,
                filterTags,
                "filterDimensionValues",
                KPIWidgetFilterDimensionValues[i]
              ),
            });
          });
        }

        if (KPILocalFilters) {
          const KPILocalFilterDimensions = KPILocalFilters.filterDimensions;
          const KPILocalFilterDimensionValues = KPILocalFilters.filterDimensionValues;

          KPILocalFilterDimensions.forEach((d, i) => {
            filterTags.set(d, {
              filterDimension: d,
              filterDimensionValues: __getCombinedUniqueVals(
                d,
                filterTags,
                "filterDimensionValues",
                KPILocalFilterDimensionValues[i]
              ),
            });
          });
        }
      });
    }

    return [...filterTags.values()];
  }, [selectedView, KPIWiseFilters, KPIWiseLocalFilters]);
}

// Get combined unique values from a map value item
function __getCombinedUniqueVals(key, map, keyToCombine, keysToCombineValue) {
  if (map.has(key)) {
    const existingKeys = map.get(key)[keyToCombine];
    return [...new Set([...existingKeys, ...keysToCombineValue])];
  } else {
    return [...keysToCombineValue];
  }
}

export { useFilterTags };
